import React from "react";
import classNames from "classnames";
import Typography from "@/ui/Typography/Typography";
import cls from "./styles.module.scss";

export type ButtonVariant =
  | "primary"
  | "secondary"
  | "success"
  | "text"
  | "outlined"
  | "ghost"
  | "dark"
  | "light"
  | "graphite"
  | "iconOnly"
  | "danger";

interface ButtonProps {
  label?: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  loading?: boolean;
  variant?: ButtonVariant;
  icon?: React.ReactNode;
  iconPosition?: "left" | "right";
  iconClassName?: string;
  stopPropagation?: boolean;
  split?: boolean;
  className?: string;
}

const Button: React.FC<ButtonProps> = ({
  label,
  onClick,
  type = "button",
  disabled = false,
  loading = false,
  variant = "primary",
  icon,
  iconPosition = "left",
  iconClassName,
  stopPropagation,
  split = false,
  className = "",
}) => {
  const isDisabled = disabled || loading;
  const variantClass = cls[variant];

  const click = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (stopPropagation) e.stopPropagation();
    onClick(e);
  };

  return (
    <button
      className={classNames(
        cls.button,
        variantClass,
        { [cls.split]: split },
        { [cls.disabled]: isDisabled },
        className
      )}
      onClick={click}
      disabled={isDisabled}
      type={type}
    >
      {loading ? (
        <div className={cls.spinner} aria-label="Loading" />
      ) : (
        <>
          {variant === "iconOnly" && icon}
          {variant !== "iconOnly" && icon && iconPosition === "left" && (
            <div className={classNames(cls.icon, iconClassName)}>{icon}</div>
          )}
          {variant !== "iconOnly" && label && (
            <Typography size="md" weight="semibold">
              {label}
            </Typography>
          )}
          {variant !== "iconOnly" && icon && iconPosition === "right" && (
            <div className={classNames(cls.icon, iconClassName)}>{icon}</div>
          )}
        </>
      )}
    </button>
  );
};

export default Button;
